var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('views/navigation/OrganizationView',['require','jquery','underscore','moment','evertrue','ET/ETView','collections/organization/OrganizationCollection','views/modals/ProductModalView','models/organization/OrganizationModel','views/components/FormView','models/dna/DnaModel','helpers/timezone-helper'],function(require) {
  var $, DnaModel, ETView, EverTrue, FormView, OrganizationCollection, OrganizationModel, OrganizationView, ProductModalView, TimezoneHelper, moment, _;
  $ = require("jquery");
  _ = require("underscore");
  moment = require("moment");
  EverTrue = require("evertrue");
  ETView = require("ET/ETView");
  OrganizationCollection = require("collections/organization/OrganizationCollection");
  ProductModalView = require("views/modals/ProductModalView");
  OrganizationModel = require("models/organization/OrganizationModel");
  FormView = require("views/components/FormView");
  DnaModel = require("models/dna/DnaModel");
  TimezoneHelper = require("helpers/timezone-helper");
  return OrganizationView = (function(_super) {
    __extends(OrganizationView, _super);

    function OrganizationView() {
      return OrganizationView.__super__.constructor.apply(this, arguments);
    }

    OrganizationView.prototype.template = "OrganizationList.html";

    OrganizationView.prototype.namespace = "organizations";

    OrganizationView.prototype.className = "side-nav side-nav-right nav-chrome";

    OrganizationView.prototype.container = "#app";

    OrganizationView.prototype.events = {
      "click .add-org": "showOrganizationModal",
      "click .refresh-orgs": "refreshOrgs",
      "click li > a:not(.add-org, .refresh-orgs)": "startSwitchingOrganization",
      "keyup input[name='search']": "filter"
    };

    OrganizationView.prototype.initialize = function() {
      this.addModals();
      $(this.container).after(this.$el);
      this.filteredOrgs = new OrganizationCollection;
      this.filteredOrgs.on("reset", this.renderResults, this);
      EverTrue.Organizations = EverTrue.Organizations || new OrganizationCollection;
      EverTrue.Organizations.on("reset", this.resetOrgList, this);
      this.refreshOrgs();
      this.collection = EverTrue.Organizations;
      this.render();
      return EverTrue.vent.on("closeOrgNav", ((function(_this) {
        return function() {
          return _this.$el.removeClass("open");
        };
      })(this)), this);
    };

    OrganizationView.prototype.refreshOrgs = function() {
      return EverTrue.Organizations.fetch({
        reset: true
      });
    };

    OrganizationView.prototype.resetOrgList = function() {
      return this.filteredOrgs.reset(EverTrue.Organizations.toJSON());
    };

    OrganizationView.prototype.filter = function(e) {
      var $target, filteredArray, matcher, val, value;
      $target = e ? $(e.target) : null;
      value = ($target != null ? $target.is("input") : void 0) && $target.val() ? $target.val() : null;
      if (value) {
        val = EverTrue.regexEscape(value);
        matcher = new RegExp(val, "i");
        filteredArray = EverTrue.Organizations.filter(function(model) {
          var nameMatch, oidMatch, slugMatch;
          oidMatch = matcher.test(model.get("id"));
          nameMatch = matcher.test(model.get("name"));
          slugMatch = matcher.test(model.get("slug"));
          return oidMatch || nameMatch || slugMatch;
        });
        return this.filteredOrgs.reset(filteredArray);
      } else {
        return this.filteredOrgs.reset(EverTrue.Organizations.toJSON());
      }
    };

    OrganizationView.prototype.showOrganizationModal = function(e) {
      return this.organizationFormModal.$el.modal("show");
    };

    OrganizationView.prototype.showProductModal = function(id) {
      if (id) {
        this.productsDialog.setId(id);
      }
      return this.productsDialog.$el.modal("show");
    };

    OrganizationView.prototype.addModals = function() {
      this.addProductModal();
      return this.addOrganizationModal();
    };

    OrganizationView.prototype.addProductModal = function() {
      this.productsDialog = new ProductModalView;
      return $("body").append(this.productsDialog.$el);
    };

    OrganizationView.prototype.addOrganizationModal = function() {
      var FV, organizationFormObj;
      organizationFormObj = {
        modal: "mNewOrg",
        fieldset: [
          {
            legend: "Create a New Organization",
            formElements: [
              {
                type: "text",
                label: "Organization Name",
                key: "org_name",
                parsley: "data-required=true"
              }, {
                type: "text",
                label: "Slug Name",
                key: "org_slug",
                parsley: "data-regexp=^[a-z]+$"
              }, {
                type: "text",
                label: "Number of Records",
                key: "number_of_records",
                parsley: "data-required=true data-regexp=^[0-9]*$"
              }, {
                type: "select",
                label: "Timezone",
                key: "timezone",
                parsley: "data-required=true",
                select: [
                  {
                    val: void 0,
                    val_display: "Select Timezone"
                  }
                ].concat(TimezoneHelper.getFormattedList())
              }
            ]
          }
        ]
      };
      FV = FormView.extend({
        onFormSubmit: _.bind(this.submitNewOrg, this),
        formObj: organizationFormObj
      });
      this.organizationFormModal = new FV;
      return $("body").append(this.organizationFormModal.$el);
    };

    OrganizationView.prototype.submitNewOrg = function(data, e, context) {
      var new_org;
      this.loading(true, $("#mNewOrg").find(".modal-body"));
      new_org = new OrganizationModel;
      return new_org.create(data, (function(_this) {
        return function(resp) {
          var new_dna;
          new_dna = new DnaModel();
          return new_dna.update({
            "ET.Importer.TimeZone": data.timezone
          }, {
            urlOverride: {
              params: {
                oid: resp.id
              }
            },
            success: function() {
              return _this.doneCreatingOrg(resp);
            },
            error: function() {
              _this.doneCreatingOrg(resp);
              return EverTrue.alertView.alert("error", {
                message: "Timezone failed to save."
              });
            }
          });
        };
      })(this));
    };

    OrganizationView.prototype.doneCreatingOrg = function(org_resp) {
      EverTrue.DNA.forceUpdate();
      this.collection.fetch({
        forceUpdate: true
      });
      this.loading(false, $("#mNewOrg").find(".modal-body"));
      $("#mNewOrg").modal("hide");
      EverTrue.alertView.alert("success", {
        message: "Organization Created"
      });
      return this.showProductModal(org_resp.id);
    };

    OrganizationView.prototype.startSwitchingOrganization = function(e) {
      var $target, name, oid;
      $target = $(e.target).closest("a");
      oid = $target.data("oid");
      name = $target.data("name");
      if (oid !== EverTrue.Organization.get("id")) {
        EverTrue.vent.trigger("closeOrgNav");
        EverTrue.alertView.alert("info", {
          message: "Changing organizations..."
        });
        if (EverTrue.Session.get("id")) {
          EverTrue.Organization.set({
            id: oid
          }, {
            silent: true
          });
          return EverTrue.Organization.fetch(function(response) {
            EverTrue.amplify("organization", response);
            EverTrue.amplify("user", EverTrue.User.toJSON());
            return EverTrue.Router._enterApp(EverTrue.Session.get("id"), oid, {
              success: function() {
                return window.location.reload();
              }
            });
          });
        } else {
          EverTrue.logout();
          return EverTrue.alertView.alert("error", {
            message: "Session is no longer valid."
          });
        }
      } else {
        return $(".side-nav-right").removeClass("open");
      }
    };

    OrganizationView.prototype.setActive = function() {
      var activeOrgModArray, current_id;
      current_id = EverTrue.Organization.get("id");
      activeOrgModArray = this.filteredOrgs.findWhere({
        id: current_id
      });
      if (activeOrgModArray) {
        return activeOrgModArray.set({
          active: true
        });
      }
    };

    OrganizationView.prototype.renderResults = function() {
      var tmplData;
      this.setActive();
      tmplData = this.filteredOrgs.toJSON();
      return EverTrue.fetchTemplate(this.template, (function(_this) {
        return function(name) {
          return dust.render(name, {
            organizations: tmplData
          }, function(err, out) {
            return _this.$(".results").html(out);
          });
        };
      })(this));
    };

    OrganizationView.prototype.render = function(done) {
      this.setActive();
      return EverTrue.fetchTemplate("OrganizationPickList.html", (function(_this) {
        return function(name) {
          return dust.render(name, {}, function(err, out) {
            return _this.$el.html(out);
          });
        };
      })(this));
    };

    return OrganizationView;

  })(ETView);
});

//# sourceMappingURL=OrganizationView.js.map
;
